
/* injects from baggage-loader */

const timerModule = angular.module('timer.setting', []);

timerModule.directive('timerSetting', [
  '$window', '$timeout', '$compile', '$templateCache', 'Widget', 'FileUploader', '$cookies', 'Restangular', 'Timer',
  ($window, $timeout, $compile, $templateCache, Widget, FileUploader, $cookies, Restangular, Timer) => {
    return {
      restrict: 'A',
      scope: {
        data: '=ngModel'
      },
      templateUrl: settingFolder + '/timer/template.jade',
      link: function(scope, element, attrs, ngModel) {
        const secondsToString = function(seconds) {
          const numdays = Math.floor(seconds / 86400);
          const numhours = Math.floor(seconds % 86400 / 3600);
          const numminutes = Math.floor(seconds % 86400 % 3600 / 60);
          const numseconds = seconds % 86400 % 3600 % 60;

          return [numdays, numhours, numminutes, numseconds];
        };

        scope.widgetInfo = {
          days: secondsToString(scope.data.seconds)[0],
          hours: secondsToString(scope.data.seconds)[1],
          minutes: secondsToString(scope.data.seconds)[2]
        };

        scope.widgetInfo.start_point = new Date(scope.data.start_point);

        const date = new Date(scope.data.time_end);
        const timend_day = date.getDate();
        const timend_month = date.getMonth() + 1;
        const timend_year = date.getFullYear();
        const timend_hours = date.getHours();
        const timend_minutes = date.getMinutes();

        scope.widgetInfo.hours_end = date;
        scope.widgetInfo.time_end = timend_year + "-" + timend_month + "-" + timend_day;
        scope.play = function() {
          scope.data.is_started = true;
          scope.data.time_end = new Date(scope.widgetInfo.time_end).setHours(new Date(scope.widgetInfo.hours_end).getHours(), new Date(scope.widgetInfo.hours_end).getMinutes(), new Date(scope.widgetInfo.hours_end).getSeconds());
          scope.data.time_end = new Date(scope.data.time_end);
          scope.data.seconds = parseInt(scope.widgetInfo.days) * 24 * 60 * 60 + parseInt(scope.widgetInfo.hours) * 60 * 60 + parseInt(scope.widgetInfo.minutes) * 60;
          scope.data.start_point = new Date(scope.widgetInfo.start_point).getTime();
          return Timer.initTimer(0, $("[data-block-id='" + scope.data.id + "'] .strbw-timer"), scope.data);
        };

        const timerEl = $("[data-block-id='" + scope.data.id + "'] .strbw-timer");
        const hidings = function(newVal) {
          if (!newVal.show_days) {
            timerEl.addClass('strbw-timer_hide-days');
          } else {
            timerEl.removeClass('strbw-timer_hide-days');
          }

          if (!newVal.show_seconds) {
            timerEl.addClass('strbw-timer_hide-seconds');
          } else {
            timerEl.removeClass('strbw-timer_hide-seconds');
          }
        };

        const themes = function(newVal) {
          let i, j;
          for (i = j = 0; j <= 4; i = ++j) {
            timerEl.removeClass("strbw-timer-theme-" + i);
          }

          timerEl.addClass("strbw-timer-theme-" + newVal.theme);
        };

        const updateLabel = function($wrapper, selector, text) {
          const $label = $wrapper.find(selector);

          if (text !== undefined && $label.length > 0) {
            $label.text(text);
          }
        };

        const labels = function(newVal) {
          updateLabel(timerEl, '.flip-clock-divider.days .flip-clock-label', newVal.days_label);
          updateLabel(timerEl, '.flip-clock-divider.hours .flip-clock-label', newVal.hours_label);
          updateLabel(timerEl, '.flip-clock-divider.minutes .flip-clock-label', newVal.minutes_label);
          updateLabel(timerEl, '.flip-clock-divider.seconds .flip-clock-label', newVal.seconds_label);
        };

        const listener = scope.$watch("data", (newVal) => {
          hidings(newVal);
          themes(newVal);
          labels(newVal);
        }, true);

        scope.$on("$destroy", () => {
          listener();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/timer/timer.directive.js